import React from 'react';
import { Translate } from '../../config/TranslationProvider';

const EventDatesCancelInfo = ({eventDatesCancelInfo}) => (
    <div className="atbd_content_module atbd_listing_details">
        <div className="alert-info">
            <div className="atbd_content_module__tittle_area" style={{paddingBottom: '0.5rem'}}>
                <div className="atbd_area_title">
                    <h2 className="h4" style={{display: 'flex', color: 'inherit'}}>
                        <span className="la la-file-text-o" style={{color: 'inherit'}} />
                        <Translate value="event_dates_cancel_info" />
                    </h2>
                </div>
            </div>

            <div
                className="atbdb_content_module_contents"
                style={{paddingTop: '0.5rem'}}
                dangerouslySetInnerHTML={{__html: eventDatesCancelInfo}}
            />
        </div>
    </div>
);

export default EventDatesCancelInfo;
